export default "__VITE_ASSET__Hc36WVAG__"